import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=34b73672&scoped=true"
import script from "./CoverPage.vue?vue&type=script&lang=js"
export * from "./CoverPage.vue?vue&type=script&lang=js"
import style0 from "./CoverPage.vue?vue&type=style&index=0&id=34b73672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b73672",
  null
  
)

export default component.exports